<template>
  <div class="mainFirmwareSetting">
    <router-view :route-model="routeModel"></router-view>
  </div>
</template>

<script>
export default {
  name: 'MainFirmwareSetting',
  components: {},
  data() {
    return {
      routeModel: {},
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        this.$set(this.routeModel, 'to', to);
        this.$set(this.routeModel, 'from', from);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    navigateTo(to) {
      this.$router.push(to);
    },
  },
};
</script>

<style lang="scss">
.mainFirmwareSetting {
  position: relative;
  height: 100%;
  &_header-divider {
    margin-top: 15px;
  }

  &_item {
    padding: 15px 0;
    cursor: pointer;
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &-desc {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
    }
  }
}
</style>
